export const defaultMessages = {
  // SIMPLE MESSAGES
  success: {
    pt: 'Sucesso',
    en: 'Success',
    es: 'Éxito',
  },
  error: {
    pt: 'Erro',
    en: 'Error',
    es: 'Erro',
  },
  image_too_large: {
    pt: 'Imagem muito grande (máx 10MB)',
    en: 'Image too large (max 10MB)',
    es: 'Imagen demasiado grande (máx 10MB)',
  },
  image_too_small: {
    pt: 'Imagem muito pequena (mín 20kb)',
    en: 'Image too small (min 20kb)',
    es: 'Imagen demasiado pequeña (mín 20kb)',
  },
  pdf_create_error: {
    pt: 'Erro ao criar PDF',
    en: 'Error creating PDF',
    es: 'Error al crear PDF',
  },
  visit_added: {
    pt: 'Visita adicionada',
    en: 'Visit added',
    es: 'Visita agregada',
  },
  visit_deleted_successfully: {
    pt: 'Visita deletada com sucesso',
    en: 'Visit deleted successfully',
    es: 'Visita eliminada con éxito',
  },
  no_visits_form_found: {
    pt: 'Não foram encontrados dados de visitas nos valores do formulário',
    en: 'No visit data found in form values',
    es: 'No se encontraron datos de visitas en los valores del formulario',
  },
  comment_updated: {
    pt: 'Comentário atualizado com sucesso',
    en: 'Comment updated successfully',
    es: 'Comentario actualizado con éxito',
  },
  comment_created: {
    pt: 'Comentário criado com sucesso',
    en: 'Comment created successfully',
    es: 'Comentario creado exitosamente',
  },
  visit_updated: {
    pt: 'Visita atualizada com sucesso',
    en: 'Visit updated successfully',
    es: 'Visita actualizada con éxito',
  },
  visit_deleted: {
    pt: 'Visita excluída com sucesso',
    en: 'Visit deleted successfully',
    es: 'Visita eliminada con éxito',
  },
  error_designers: {
    pt: 'Erro ao buscar designers',
    en: 'Error searching designers',
    es: 'Error al buscar designers',
  },
  empty: {
    pt: 'Nenhum',
    en: 'None',
    es: 'Ninguna',
  },
  welcome: {
    pt: 'Bem vindo',
    en: 'Welcome',
    es: 'Bienvenido',
  },
  terms_required: {
    pt:
      'Por favor, entrar em contato com o administrador do sistema pelo endereço plus@cte.com.br.',
    en: 'Please contact your system administrator at plus@cte.com.br.',
    es: 'Comuníquese con el administrador de su sistema en plus@cte.com.br.',
  },

  // EMPTY MESSAGES
  no_indicators: {
    pt: 'Sem indicadores',
    en: 'No indicators',
    es: 'Sin indicadores',
  },
  no_chapters: {
    pt: 'Sem capítulos',
    en: 'No chapters',
    es: 'Sin capítulos',
  },
  no_categories: {
    pt: 'Sem categorias',
    en: 'No categories',
    es: 'Sin categorias',
  },
  no_records: {
    pt: 'Sem registros',
    en: 'No records',
    es: 'Sin registros',
  },
  no_contact: {
    pt: 'Sem contatos',
    en: 'No contacts',
    es: 'Sin contactos',
  },
  no_enterprises: {
    pt: 'Sem empreendimentos',
    en: 'No enterprises',
    es: 'Sin emprendimientos',
  },
  no_company: {
    pt: 'Sem empresas',
    en: 'No companies',
    es: 'Sin compañías',
  },
  no_responsible: {
    pt: 'Sem responsável',
    en: 'No responsible',
    es: 'Sin responsable',
  },
  no_sub_functions: {
    pt: 'Não há sub-funções',
    en: 'There are no sub-functions',
    es: 'No hay subfunciones',
  },
  no_projects: {
    pt: 'Não há projetos',
    en: 'No projects',
    es: 'Sin proyectos',
  },
  no_services: {
    pt: 'Não há serviços',
    en: 'No services',
    es: 'Sin servicios',
  },
  no_status: {
    pt: 'Não há status',
    en: 'No status',
    es: 'No hay status',
  },
  no_functions: {
    pt: 'Não há funções',
    en: 'There are no functions',
    es: 'No hay funciones',
  },
  empty_indicators: {
    pt: 'Não possui indicadores cadastrados',
    en: 'Does not have registered indicators',
    es: 'No tiene indicadores registrados',
  },
  empty_message_action_plan: {
    pt: 'Não possui plano de ação cadastrado',
    en: 'No action plan registered',
    es: 'Ningún plan de acción registrado',
  },
  empty_message: {
    pt: 'Não possui item cadastrado',
    en: 'No item registered',
    es: 'Ningún artículo registrado',
  },
  empty_files: {
    pt: 'Nenhum arquivo cadastrado',
    en: 'No files',
    es: 'No hay archivos registrados',
  },
  empty_register: {
    pt: 'Nenhum registro cadastrado',
    en: 'No records',
    es: 'No hay registros registrados',
  },
  no_columns_created: {
    pt: 'Nenhum campo cadastrado',
    en: 'No fields created',
    es: 'No hay campos registrados',
  },
  no_formOfService_selected: {
    pt: 'Nenhuma forma de atendimento selecionada',
    en: 'No form of service selected',
    es: 'Ninguna forma de servicio seleccionada',
  },
  not_defined: {
    pt: 'Não definido',
    en: 'Not defined',
    es: 'No definido',
  },
  comment_deleted: {
    pt: 'Comentário excluído',
    en: 'Comment deleted',
    es: 'Comentario eliminado',
  },

  // NOT FOUND MESSAGES
  columns_not_found: {
    pt: 'Campos não encontrados',
    en: 'Fields not found',
    es: 'Campos no encontrados',
  },
  empty_message_filtered: {
    pt: 'Nenhum item encontrado',
    en: 'No items found',
    es: 'No se encontraron artículos',
  },
  status_not_found: {
    pt: 'Status não encontrado',
    en: 'Status not found',
    es: 'Status no encontrado',
  },
  service_not_found: {
    pt: 'Serviço não encontrado',
    en: 'Service not found',
    es: 'Servicio no encontrado',
  },
  projects_not_found: {
    pt: 'Projetos não encontrados',
    en: 'Projects not found',
    es: 'Proyectos no encontrados',
  },
  companies_not_found: {
    pt: 'Empresas não encontradas',
    en: 'Companies not found',
    es: 'Compañías no encontradas',
  },
  forms_of_service_not_found: {
    pt: 'Formas de atendimento não encontradas',
    en: 'Types of attention not found',
    es: 'Formas de servicio no encontradas',
  },

  // ERROR MESSAGES
  notification_config_add: {
    pt: 'Configuração salva com sucesso',
    en: 'Configuration saved successfully',
    es: 'Configuración guardada exitosamente',
  },
  notification_config_add_error: {
    pt: 'Erro na adição da configuração',
    en: 'Error in adding the configuration',
    es: 'Error al agregar la configuración',
  },
  deleted_error: {
    pt: 'Erro na remoção',
    en: 'Removal error',
    es: 'Error de eliminación',
  },
  auto_save_error: {
    pt: 'Não foi possível salvar automaticamente devido a campos obrigatórios pendentes',
    en: 'Unable to auto-save due to pending required fields',
    es: 'No se puede guardar automáticamente debido a campos obligatorios pendientes',
  },
  draft_locked_error: {
    pt: 'Outro usuário está editando este serviço.',
    en: 'Another user is currently editing this service.',
    es: 'Otro usuario está editando este servicio.',
  },
  take_over_conflict: {
    pt: 'Outro usuário assumiu a edição — suas últimas alterações não foram salvas.',
    en: 'Another user took over editing — your latest changes were not saved.',
    es: 'Otro usuario asumió la edición — tus últimos cambios no se guardaron.',
  },
  get_project_error: {
    pt: 'Houve um erro ao tentar capturar os arquivos.',
    en: 'There was an error trying to capture the files.',
    es: 'Hubo un error al intentar capturar los archivos.',
  },
  create_project_error: {
    pt: 'Houve um erro no cadastro do projeto.',
    en: 'There was an error in the project registration.',
    es: 'Hubo un error en el registro del proyecto.',
  },
  create_work_error: {
    pt: 'Houve um erro no cadastro do modelo.',
    en: 'There was an error in the work registration.',
    es: 'Hubo un error en el registro del modelo.',
  },
  update_work_success: {
    pt: 'Modelo atualizado com sucesso',
    en: 'Model updated successfully',
    es: 'Modelo actualizado con éxito',
  },
  error_analysis_exclude_message: {
    pt: 'Não foi possível excluir análise',
    en: 'Unable to delete analysis',
    es: 'No se puede eliminar el análisis',
  },
  error_exclude_file: {
    pt: 'Não foi possível excluir o arquivo',
    en: 'Unable to delete file',
    es: 'No se puede eliminar el archivo',
  },
  error_no_files_found: {
    pt: 'Não foi encontrado arquivos',
    en: 'No files found',
    es: 'No se encontraron archivos',
  },
  error_analysis_approve_message: {
    pt: 'Não foi possível aprovar análise',
    en: 'Unable to approve review',
    es: 'No se puede aprobar la revisión',
  },
  error_comment_approve_message: {
    pt: 'Não foi possível aprovar commentario',
    en: 'Unable to approve comment',
    es: 'No se puede aprobar el comentario',
  },
  service_completed_error: {
    pt: 'Erro no preenchimento do serviço',
    en: 'Error completing the service',
    es: 'Error al completar el servicio',
  },
  visit_status_option_error: {
    pt: 'Erro ao buscar opções de status da visita',
    en: 'Error fetching visit status options',
    es: 'Error al buscar opciones de estado de visita',
  },
  description_update_error: {
    pt: 'Erro ao atualizar a descrição',
    en: 'Error updating description',
    es: 'Error al actualizar la descripción',
  },
  add_new_status_error: {
    pt: 'Erro ao adicionar status',
    en: 'Error adding status',
    es: 'Error al agregar el estado',
  },

  update_comment_error: {
    pt: 'Erro na atualização do comentário',
    en: 'Comment update error',
    es: 'Error de actualización de comentarios',
  },
  create_comment_error: {
    pt: 'Erro na criação do comentário',
    en: 'Error creating comment',
    es: 'Error al crear comentario',
  },
  error_capturing_data: {
    pt: 'Erro na captura dos dados',
    en: 'Error capturing data',
    es: 'Error en la captura de datos',
  },

  // DESCRIPTIONS MESSAGES
  select_status: {
    pt: 'Selecione o status',
    en: 'Select the status',
    es: 'Seleccione el estado',
  },
  repeat_new_password: {
    pt: 'Repetir nova senha',
    en: 'Repeat new password',
    es: 'Repita la nueva contraseña',
  },
  rule_and_or: {
    pt: '(Regra E) ou (Regra OU)?',
    en: '(Rule AND) or (Rule OR)?',
    es: '¿(Regla Y) o (Regla O)?',
  },
  use_expanded_screen: {
    pt: 'Use tela expandida (Power BI)',
    en: 'Use expanded screen (Power BI)',
    es: 'Usar pantalla ampliada (Power BI)',
  },
  dragger_file_text: {
    pt: 'Clique ou arraste um arquivo para esta área',
    en: 'Click or drag an file to this area',
    es: 'Clic o arrastre un archivo a esta área',
  },
  dragger_text: {
    pt: 'Clique ou arraste uma imagem para esta área',
    en: 'Click or drag an image to this area',
    es: 'Clic o arrastre una imagen a esta área',
  },
  carbon_emission_per_area: {
    pt: 'Emissão de CO2eq por área (kgCO2eq /m²)',
    en: 'CO2eq emission per area (kgCO2eq /m²)',
    es: 'Emisión de CO2eq por área (kgCO2eq / m²)',
  },
  percentage_of_carbon_emission_reduction: {
    pt: '% de redução nas emissões de CO2eq',
    en: '% reduction in CO2eq emissions',
    es: '% de reducción de emisiones de CO2eq',
  },
  construction_waste_indicators: {
    pt: 'Indicadores de resíduos de obra',
    en: 'Construction waste indicators',
    es: 'Indicadores de residuos de construcción',
  },
  construction_waste_quantity_per_area: {
    pt: 'Quantidade de resíduos de obra gerado por área (kg/m²)',
    en: 'Amount of construction waste generated per area (kg/m²)',
    es: 'Cantidad de residuos de construcción generados por área (kg / m²)',
  },
  percentage_of_construction_waste_diverted: {
    pt: '% de resíduo de obra desviado de aterro',
    en: '% of construction waste diverted from landfill',
    es: '% de residuos de la construcción desviados del vertedero',
  },
  percentage_of_waste_generated_on_site_by_type: {
    pt: '% de resíduo gerado em obra por tipo',
    en: '% of waste generated on site by type',
    es: '% de residuos generados en el sitio por tipo',
  },
  percentage_of_reduction_of_energy_consumption_in_kwh: {
    pt: '% de redução do consumo anual de energia (%)',
    en: '% of annual reduction of energy consumption (%)',
    es: '% de reducción anual del consumo de energía (%)',
  },
  percentage_of_reduction_of_energy_consumption_in_cash: {
    pt: '% de redução do custo anual de energia (R$)',
    en: '% of annual energy cost reduction (R$)',
    es: '% de reducción anual del costo de energía (R$)',
  },
  installed_thermal_capacity: {
    pt: 'Capacidade térmica instalada (TR/m²)',
    en: 'Installed thermal capacity (TR/m²)',
    es: 'Capacidad térmica instalada (TR/m²)',
  },
  percentage_of_energy_consumption_by_source: {
    pt: '% de consumo de energia por fonte',
    en: '% of energy consumption by source',
    es: '% del consumo de energía por fuente',
  },
  eui: {
    pt: 'EUI - intensidade de consumo de energia (kWh/m²)',
    en: 'EUI - energy consumption intensity (kWh/m²)',
    es: 'EUI - intensidad de consumo de energía (kWh/m²)',
  },
  percentage_of_reduction_in_water_consumption_for_sanitary: {
    pt: '% de redução do consumo de água potável para dispositivos sanitários',
    en: '% of reduction in water consumption for sanitary devices',
    es: '% de reducción del consumo de agua potable para dispositivos sanitarios',
  },
  percentage_of_non_potable_water_consumption: {
    pt: '% de consumo de água não potável',
    en: '% of non potable water consumption',
    es: '% del consumo de agua no potable',
  },
  percentage_of_reduction_in_total_water_consumption: {
    pt: '% de redução do consumo de água total',
    en: '% of reduction in total water consumption',
    es: '% de reducción del consumo total de agua',
  },
  percentage_of_efficiency_of_the_irrigation_system: {
    pt: '% de eficiência do sistema de irrigação',
    en: '% of the irrigation system efficiency',
    es: '% de eficiencia del sistema de riego',
  },
  percentage_of_water_consumption_by_source: {
    pt: '% de consumo de água por fonte',
    en: '% of water consumption by source',
    es: '% de consumo de agua por fuente',
  },
  comparison: {
    pt: 'Meta de melhores práticas deve ser maior que a Meta de boas práticas',
    en: 'Better practice goal should be greater than good practice goal',
    es:
      'El objetivo de las mejores prácticas debe ser mayor que el objetivo de las buenas prácticas',
  },
  description_suport: {
    pt: 'Caso tenha alguma dúvida ou precise de suporte, entre em contato pelo email:',
    en: 'If you have any questions or need support, please contact us by email:',
    es: 'Si tiene alguna pregunta o necesita ayuda, contáctenos por correo electrónico:',
  },
  attended_description: {
    pt: 'Atendido, considerando a documentação disponível ou a sua efetiva implantação in loco.',
    en: 'Attended, considering the available documentation or its implantation in loco.',
    es: 'Atendido, considerando la documentación disponible o su efectiva implantación in loco.',
  },
  intervention_level_one_description: {
    pt:
      'Ações menos complexas ou previstas para o empreendimento, necessitando tecnologias e investimentos mais acessíveis.',
    en:
      'Less complex or planned actions for the enterprise, requiring cheaper technologies and less investments.',
    es:
      'Acciones menos complejas o planejadas para el emprendimiento, que requieren tecnologías e inversiones más accesibles.',
  },
  intervention_level_two_description: {
    pt: 'Ações mais complexas, necessitando os estudos de viabilidade técnica e econômica.',
    en: 'More complex actions, requiring technical and economic feasibility studies.',
    es: 'Actuaciones más complejas, que requieren estudios de viabilidad técnica y económica.',
  },
  not_attended_description: {
    pt:
      'As estratégias necessárias para atendimento do crédito não foram e não serão incorporadas.',
    en: 'The strategies required to meet credit were not and will not be incorporated.',
    es: 'Las estrategias requeridas para cumplir con el crédito no fueron y ni serán incorporadas.',
  },
  not_pleated_description: {
    pt:
      'As estratégias necessárias para o atendimento dos requisitos não foram estabelecidas como meta para o projeto.',
    en:
      'The necessary strategies to meet the requirements were not established as a goal for the project.',
    es:
      'Las estrategias necesarias para cumplir con los requisitos no se establecieron como meta del proyecto.',
  },

  cte_analysis_placeholder: {
    pt:
      'Neste campo, deve ser preenchido com breves detalhes da revisão sobre a certificação neste empreendimento feita durante a criação da certificação ',
    en:
      'This field must be filled in with brief details of the review about the certification in this enterprise made during the creation of the certification ',
    es:
      'Este campo debe completarse con breves detalles de la revisión sobre la certificación en esta empresa realizada durante la creación de la certificación',
  },

  clear_all_notifications: {
    pt: 'Todas as notificações foram apagadas com sucesso.',
    en: 'All notifications have been successfully deleted.',
    es: 'Todas las notificaciones se han eliminado correctamente.',
  },

  error_clear_all_notifications: {
    pt: 'Erro ao limpar todas as notificações.',
    en: 'Error deleting all notifications.',
    es: 'Error al eliminar todas las notificaciones.',
  },

  tooltip_chart: {
    pt:
      'Como procedimento, a qualidade das atividades verificadas para atendimento dos créditos e pré-requisitos de obra são monitoradas em todas as visitas realizadas por um checklist de controle padronizado. Os itens em conformidade são contabilizados e comparados com os demais pontos avaliados, obtendo como resultado a porcentagem média de conformidade da obra para cada um dos temas, conforme apresentado no gráfico.',
    en: `As a procedure, the quality of activities verified to meet the project's credits and prerequisites is monitored during all visits using a standardized control checklist. Compliant items are tallied and compared with the other assessed points, resulting in the average percentage of project compliance for each topic, as shown in the graph.`,
    es:
      'Como procedimiento, durante todas las visitas se supervisa la calidad de las actividades verificadas para cumplir con los créditos y prerrequisitos del proyecto mediante una lista de verificación de control estandarizada. Los elementos que cumplen se contabilizan y se comparan con los demás puntos evaluados, lo que genera el porcentaje promedio de cumplimiento del proyecto para cada tema, como se muestra en el gráfico.',
  },

  create_work_success: {
    pt: 'Modelo criado com sucesso',
    en: 'Model created successfully',
    es: 'Modelo creado con éxito',
  },

  edit_work_success: {
    pt: 'Modelo editado com sucesso',
    en: 'Model edited successfully',
    es: 'Modelo editado con éxito',
  },
  duplicate_work_success: {
    pt: 'Modelo duplicado com sucesso',
    en: 'Model duplicated successfully',
    es: 'Modelo duplicado con éxito',
  },
  duplicate_work_error: {
    pt: 'Erro ao duplicar modelo',
    en: 'Error duplicating model',
    es: 'Error al duplicar el modelo',
  },

  loading: {
    pt: 'Carregando...',
    en: 'Loading...',
    es: 'Cargando...',
  },

  uploading_image: {
    pt: 'Enviando imagem...',
    en: 'Uploading image...',
    es: 'Subiendo imagen...',
  },

  no_work_data: {
    pt: 'Nenhum dado de modelo encontrado',
    en: 'No model data found',
    es: 'No se encontraron datos del modelo',
  },

  no_visits_found: {
    pt: 'Nenhuma visita encontrada',
    en: 'No visits found',
    es: 'No se encontraron visitas',
  },

  add_first_visit: {
    pt: 'Adicione nova visita',
    en: 'Add new visit',
    es: 'Agregue nueva visita',
  },

  select_visit: {
    pt: 'Selecionar Visita',
    en: 'Select Visit',
    es: 'Seleccionar Visita',
  },

  visit_label_name: {
    pt: 'Visita ',
    en: 'Visit ',
    es: 'Visita ',
  },

  status_updated_successfully: {
    pt: 'Status atualizado com sucesso',
    en: 'Status updated successfully',
    es: 'Estado actualizado exitosamente',
  },

  status_deleted_successfully: {
    pt: 'Status excluídos com sucesso',
    en: 'Statuses successfully deleted',
    es: 'Estados eliminados exitosamente',
  },

  current_status: {
    pt: 'Status Atual',
    en: 'Current Status',
    es: 'Estado actual',
  },

  remove_action_plan_success: {
    pt: 'Plano de ação removido com sucesso',
    en: 'Action plan removed successfully',
    es: 'Plan de acción eliminado con éxito',
  },

  indicator_form_warning: {
    pt: 'Preencha pelo menos um campo de indicador antes de adicionar.',
    en: 'Fill in at least one indicator field before adding.',
    es: 'Complete al menos un campo de indicador antes de agregar.',
  },

  indicator_form_dot: {
    pt: 'Alterar o ponto por vírgula',
    en: 'Change dot to comma',
    es: 'Cambiar punto por coma',
  },

  indicator_form_success: {
    pt: 'valor(es) adicionado(s) com sucesso!',
    en: 'value(s) added successfully!',
    es: '¡valor(es) agregado(s) con éxito!',
  },

  fetch_indicators_error: {
    pt: 'Erro ao carregar os indicadores do projeto',
    en: 'Error loading project indicators',
    es: 'Error al cargar los indicadores del proyecto',
  },

  // ─── v1.10 — Performance (Desempenho) error messages ──────────────────────
  goal_save_error: {
    pt: 'Não foi possível salvar a meta de desempenho. Verifique sua conexão e tente novamente.',
    en: 'Could not save the performance goal. Check your connection and try again.',
    es: 'No se pudo guardar la meta de rendimiento. Verifique su conexión e inténtelo de nuevo.',
  },
  indicator_change_error: {
    pt: 'Não foi possível alterar o indicador. Sua sessão pode ter expirado.',
    en: 'Could not change the indicator. Your session may have expired.',
    es: 'No se pudo cambiar el indicador. Su sesión puede haber expirado.',
  },
  load_performance_error: {
    pt: 'Não foi possível carregar os dados do indicador de desempenho.',
    en: 'Could not load the performance indicator data.',
    es: 'No se pudieron cargar los datos del indicador de rendimiento.',
  },
  visit_save_error: {
    pt: 'Não foi possível salvar a visita. Verifique se todos os campos obrigatórios estão preenchidos.',
    en: 'Could not save the visit. Check that all required fields are filled in.',
    es: 'No se pudo guardar la visita. Verifique que todos los campos obligatorios estén completos.',
  },
  visit_update_error: {
    pt: 'Não foi possível atualizar a visita. Tente novamente em alguns instantes.',
    en: 'Could not update the visit. Please try again in a moment.',
    es: 'No se pudo actualizar la visita. Vuelva a intentarlo en unos instantes.',
  },
  visit_delete_error: {
    pt: 'Não foi possível excluir a visita. Pode haver dados relacionados que impedem a remoção.',
    en: 'Could not delete the visit. Related data may be preventing the removal.',
    es: 'No se pudo eliminar la visita. Puede haber datos relacionados que impiden la eliminación.',
  },
  visit_clone_error: {
    pt: 'Não foi possível duplicar a visita. Tente novamente.',
    en: 'Could not clone the visit. Please try again.',
    es: 'No se pudo duplicar la visita. Vuelva a intentarlo.',
  },
  comment_save_error: {
    pt: 'Não foi possível salvar o comentário. Verifique o conteúdo e tente novamente.',
    en: 'Could not save the comment. Check the content and try again.',
    es: 'No se pudo guardar el comentario. Verifique el contenido e inténtelo de nuevo.',
  },
  comment_delete_error: {
    pt: 'Não foi possível excluir o comentário.',
    en: 'Could not delete the comment.',
    es: 'No se pudo eliminar el comentario.',
  },
  comment_load_error: {
    pt: 'Não foi possível carregar os comentários.',
    en: 'Could not load the comments.',
    es: 'No se pudieron cargar los comentarios.',
  },
  comment_read_error: {
    pt: 'Não foi possível marcar os comentários como lidos.',
    en: 'Could not mark the comments as read.',
    es: 'No se pudieron marcar los comentarios como leídos.',
  },

  // ─── v1.10 — Works Report (Relatório de Obras) error messages ─────────────
  status_options_load_error: {
    pt: 'Não foi possível carregar as opções de status.',
    en: 'Could not load the status options.',
    es: 'No se pudieron cargar las opciones de estado.',
  },
  status_save_error: {
    pt: 'Não foi possível salvar o status da visita. Tente novamente.',
    en: 'Could not save the visit status. Please try again.',
    es: 'No se pudo guardar el estado de la visita. Vuelva a intentarlo.',
  },
  status_update_error: {
    pt: 'Não foi possível atualizar o status.',
    en: 'Could not update the status.',
    es: 'No se pudo actualizar el estado.',
  },
  status_delete_error: {
    pt: 'Não foi possível remover o status.',
    en: 'Could not remove the status.',
    es: 'No se pudo eliminar el estado.',
  },
  visit_work_add_error: {
    pt: 'Não foi possível adicionar a visita ao item. Verifique se você tem permissão.',
    en: 'Could not add the visit to the item. Check if you have permission.',
    es: 'No se pudo agregar la visita al ítem. Verifique si tiene permiso.',
  },
  action_plan_create_error: {
    pt: 'Não foi possível adicionar o item de ação. Verifique sua sessão e tente novamente.',
    en: 'Could not add the action item. Check your session and try again.',
    es: 'No se pudo agregar el ítem de acción. Verifique su sesión y vuelva a intentarlo.',
  },
  action_plan_delete_error: {
    pt: 'Não foi possível remover o item de ação.',
    en: 'Could not remove the action item.',
    es: 'No se pudo eliminar el ítem de acción.',
  },
  action_plan_update_error: {
    pt: 'Não foi possível atualizar o item de ação.',
    en: 'Could not update the action item.',
    es: 'No se pudo actualizar el ítem de acción.',
  },
  technical_analysis_save_error: {
    pt: 'Não foi possível salvar a análise técnica. Verifique a descrição e tente novamente.',
    en: 'Could not save the technical analysis. Check the description and try again.',
    es: 'No se pudo guardar el análisis técnico. Verifique la descripción e inténtelo de nuevo.',
  },
  technical_analysis_delete_error: {
    pt: 'Não foi possível remover a análise técnica.',
    en: 'Could not remove the technical analysis.',
    es: 'No se pudo eliminar el análisis técnico.',
  },
  file_upload_error: {
    pt: 'Não foi possível enviar o arquivo. Verifique o tamanho e o formato.',
    en: 'Could not upload the file. Check the size and format.',
    es: 'No se pudo cargar el archivo. Verifique el tamaño y el formato.',
  },
  file_delete_error: {
    pt: 'Não foi possível remover o arquivo.',
    en: 'Could not remove the file.',
    es: 'No se pudo eliminar el archivo.',
  },
  file_load_error: {
    pt: 'Não foi possível carregar os arquivos.',
    en: 'Could not load the files.',
    es: 'No se pudieron cargar los archivos.',
  },
  image_upload_error: {
    pt: 'Não foi possível enviar a imagem. Verifique o tamanho e o formato.',
    en: 'Could not upload the image. Check the size and format.',
    es: 'No se pudo cargar la imagen. Verifique el tamaño y el formato.',
  },
  image_delete_error: {
    pt: 'Não foi possível remover a imagem.',
    en: 'Could not remove the image.',
    es: 'No se pudo eliminar la imagen.',
  },
  image_load_error: {
    pt: 'Não foi possível carregar as imagens.',
    en: 'Could not load the images.',
    es: 'No se pudieron cargar las imágenes.',
  },
  unauthorized_session_error: {
    pt: 'Sessão expirada ou sem permissão. Faça login novamente.',
    en: 'Session expired or no permission. Please log in again.',
    es: 'Sesión expirada o sin permiso. Inicie sesión de nuevo.',
  },
  project_indicator_save_error: {
    pt: 'Não foi possível adicionar todos os indicadores ao projeto.',
    en: 'Could not add all indicators to the project.',
    es: 'No se pudieron agregar todos los indicadores al proyecto.',
  },
  project_indicator_remove_error: {
    pt: 'Não foi possível remover todos os indicadores do projeto.',
    en: 'Could not remove all indicators from the project.',
    es: 'No se pudieron eliminar todos los indicadores del proyecto.',
  },
  project_indicator_save_partial_error: {
    pt: 'Alguns indicadores foram salvos, mas outros falharam. Verifique a lista e tente novamente.',
    en: 'Some indicators were saved, but others failed. Please check the list and try again.',
    es: 'Algunos indicadores se guardaron, pero otros fallaron. Revise la lista e inténtelo de nuevo.',
  },
  project_indicator_payload_invalid_error: {
    pt: 'Os indicadores selecionados não correspondem ao serviço atual. Recarregue a página e tente novamente.',
    en: 'The selected indicators do not match the current service. Reload the page and try again.',
    es: 'Los indicadores seleccionados no coinciden con el servicio actual. Recargue la página e inténtelo de nuevo.',
  },
  save_service_indicators_error: {
    pt: 'Não foi possível salvar os valores dos indicadores. Tente novamente.',
    en: 'Could not save the indicator values. Please try again.',
    es: 'No se pudieron guardar los valores de los indicadores. Inténtelo de nuevo.',
  },
  class_indicator_save_error: {
    pt: 'Não foi possível salvar o indicador. Sua sessão pode ter expirado.',
    en: 'Could not save the indicator. Your session may have expired.',
    es: 'No se pudo guardar el indicador. Su sesión puede haber expirado.',
  },
  class_indicator_delete_error: {
    pt: 'Não foi possível excluir o indicador. Sua sessão pode ter expirado.',
    en: 'Could not delete the indicator. Your session may have expired.',
    es: 'No se pudo eliminar el indicador. Su sesión puede haber expirado.',
  },

  // Popup shown when a visit is created from Performance, offering to create
  // it inside the works-report items in one go. Keys are prefixed
  // `visit_items_` because pageLanguage spreads defaultMessages before
  // common/newItems/actions — a name collision there would be lost silently.
  visit_items_modal_title: {
    pt: 'Criar esta visita nos itens do relatório?',
    en: 'Create this visit inside the report items?',
    es: '¿Crear esta visita en los ítems del informe?',
  },
  visit_items_modal_description: {
    pt: 'Selecione os itens do Relatório de Obras em que a visita deve ser criada automaticamente. Todos vêm marcados.',
    en: 'Select the works report items where the visit should be created automatically. All are selected by default.',
    es: 'Seleccione los ítems del Informe de Obras en los que la visita debe crearse automáticamente. Todos vienen marcados.',
  },
  visit_items_placeholder: {
    pt: 'Selecione os itens',
    en: 'Select the items',
    es: 'Seleccione los ítems',
  },
  visit_items_save_without: {
    pt: 'Salvar sem criar',
    en: 'Save without creating',
    es: 'Guardar sin crear',
  },
  visit_items_save_and_create: {
    pt: 'Salvar e criar nos itens',
    en: 'Save and create in the items',
    es: 'Guardar y crear en los ítems',
  },
  print_visits_label: {
    pt: 'Visitas a incluir no relatório',
    en: 'Visits to include in the report',
    es: 'Visitas a incluir en el informe',
  },
  print_visits_placeholder: {
    pt: 'Todas',
    en: 'All',
    es: 'Todas',
  },
  print_visits_hint: {
    pt: 'Marcando visitas, o relatório inclui somente elas — no Desempenho e dentro de cada item. Sem marcar nada, sai o relatório completo.',
    en: 'When visits are selected the report includes only those — in Performance and inside every item. With none selected the full report is printed.',
    es: 'Al marcar visitas, el informe incluye solo esas — en Rendimiento y dentro de cada ítem. Sin marcar ninguna, se imprime el informe completo.',
  },
  visit_items_select_all: {
    pt: 'Selecionar todos',
    en: 'Select all',
    es: 'Seleccionar todos',
  },
  visit_items_clear: {
    pt: 'Limpar',
    en: 'Clear',
    es: 'Limpiar',
  },
  visit_items_selected_count: {
    pt: '{selected} de {total} itens selecionados',
    en: '{selected} of {total} items selected',
    es: '{selected} de {total} ítems seleccionados',
  },
  visit_items_created_result: {
    pt: 'Visita salva e criada em {created} de {total} itens.',
    en: 'Visit saved and created in {created} of {total} items.',
    es: 'Visita guardada y creada en {created} de {total} ítems.',
  },
  visit_items_none_created: {
    pt: 'Visita salva, mas não foi possível criá-la nos itens. Adicione-a manualmente pelo Relatório de Obras.',
    en: 'Visit saved, but it could not be created in the items. Add it manually from the works report.',
    es: 'Visita guardada, pero no fue posible crearla en los ítems. Agréguela manualmente desde el Informe de Obras.',
  },
  visit_items_load_error: {
    pt: 'Não foi possível carregar os itens do relatório.',
    en: 'Could not load the report items.',
    es: 'No se pudieron cargar los ítems del informe.',
  },
  visit_items_try_again: {
    pt: 'Tentar novamente',
    en: 'Try again',
    es: 'Intentar de nuevo',
  },
};

export default defaultMessages;
